<div class="content">
  <ng-template #selectVessel>
    <h1>Please select a vessel</h1>
  </ng-template>

  <div class="date-picker-container" *ngIf="getSelectedVesselId(); else selectVessel">
    <div class="align-items-center flex flex-wrap gap-inner justify-content-between mb-5">
      <h1>{{ getVesselName() }}</h1>
      <app-calendar
        [isVoyageMode]="true"
        [rangeService]="getRangeService()"
        [showResetButton]="true"
        *ngIf="selectedVessel"
        (dateRange)="onDateRangeChanged($event)"></app-calendar>
    </div>
    <div class="flex flex-column gap-inner" [ngClass]="{ spinner: isLoading() }">
      <!-- TODO does not work with rowexpansion template in primeeng 15 -->
      <!--  rowGroupMode="subheader"-->
      <!--  groupRowsBy="monthYear"-->
      <div class="overflow-hidden">
        <p-table
          dataKey="voyageReportData.voyageCode"
          selectionMode="single"
          [scrollable]="true"
          scrollHeight="flex"
          sortField="voyageReportData.departureAt"
          [sortOrder]="-1"
          [value]="filteredVoyageReports">
          <ng-template pTemplate="header">
            <tr>
              <th class="w-2rem"></th>
              <th class="number" pSortableColumn="voyageReportData.voyageCode">
                Voyage Number
                <p-sortIcon field="voyageReportData.voyageCode" />
                <p-columnFilter
                  display="menu"
                  field="voyageReportData.voyageCode"
                  matchMode="contains"
                  [showMatchModes]="false"
                  [showOperator]="false"
                  [showAddButton]="false">
                </p-columnFilter>
              </th>
              <th class="departure" pSortableColumn="voyageReportData.departureAt">
                Begin
                <p-sortIcon field="voyageReportData.departureAt" />
              </th>
              <th class="arrival" pSortableColumn="voyageReportData.arrivalAt">
                End
                <p-sortIcon field="voyageReportData.arrivalAt" />
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-report let-expanded="expanded">
            <tr>
              <td>
                <p-button pRipple [pRowToggler]="report" [icon]="expanded ? 'albis-icons-chevron-down-2' : 'albis-icons-chevron-right-2'" />
              </td>
              <td>Voyage {{ report.voyageReportData.voyageCode }}</td>
              <td>
                <span *ngIf="report.voyageReportData.departureAt"> {{ report.voyageReportData.departureAt | date: "yyyy-MM-dd" }}</span>
                <span *ngIf="report.voyageReportData.departurePort"> at {{ report.voyageReportData.departurePort }}</span>
              </td>
              <td>
                <span *ngIf="report.voyageReportData.arrivalAt && report.voyageReportData.isCompleted">
                  {{ report.voyageReportData.arrivalAt | date: "yyyy-MM-dd" }}</span
                >
                <span *ngIf="report.voyageReportData.arrivalPort && report.voyageReportData.isCompleted"> at {{ report.voyageReportData.arrivalPort }}</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-report>
            <tr class="no-hover">
              <td colspan="4">
                <div class="flex flex-wrap gap-5">
                  <div class="column big">
                    <div class="column-item">
                      <div class="separator">
                        <h2 class="pl-2">Map</h2>
                      </div>
                      <app-map
                        style="display: block; width: 100%; min-width: 30rem; aspect-ratio: 19 / 9"
                        [voyageMode]="true"
                        [voyage]="report.voyageReportData"></app-map>
                      <div class="flex justify-content-center align-items-center gap-3 mt-2 text-sm w-full" style="min-width: 30rem">
                        <div class="bft-wrapper nv mr-4">
                          <div class="border-round-xl bft-scale nv"></div>
                          <div class="bft-labels">
                            <span style="left: 50%">NV</span>
                          </div>
                        </div>
                        <div class="bft-wrapper">
                          <div class="border-round-xl bft-scale"></div>
                          <div class="bft-labels">
                            <span style="left: 0%">0 Bft</span>
                            <span style="left: 8.33%">1</span>
                            <span style="left: 16.66%">2</span>
                            <span style="left: 25%">3</span>
                            <span style="left: 33.33%">4</span>
                            <span style="left: 41.66%">5</span>
                            <span style="left: 50%">6</span>
                            <span style="left: 58.33%">7</span>
                            <span style="left: 66.66%">8</span>
                            <span style="left: 75%">9</span>
                            <span style="left: 83.33%">10</span>
                            <span style="left: 91.66%">11</span>
                            <span style="left: 100%">12 Bft</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column-item">
                      <div class="separator">
                        <h2 class="pl-2">Reports</h2>
                      </div>
                      <app-reports-table [reportAndEventsValues]="report.voyageReportReportAndEventsData.reportAndEvents"></app-reports-table>
                    </div>
                  </div>
                  <div class="column">
                    <div class="column-item">
                      <div class="separator">
                        <h2 class="pl-2">Total Fuel Consumption</h2>
                      </div>
                      <app-total-fuel-consumption-diagram [totalFuelConsumptionValues]="report.voyageReportTFCRData"></app-total-fuel-consumption-diagram>
                    </div>
                    <div class="column-item">
                      <div class="separator">
                        <h2 class="pl-2">Weather at Sea</h2>
                      </div>
                      <app-weather-at-sea-diagram [weatherAtSeaValues]="report.voyageReportWeatherData"></app-weather-at-sea-diagram>
                    </div>
                    <div class="column-item">
                      <div class="separator">
                        <h2 class="pl-2">CII Rating</h2>
                      </div>
                      <app-cii-rating-diagram [ciiRatingValues]="report.voyageReportCiiRatingData"></app-cii-rating-diagram>
                    </div>
                  </div>
                  <div class="column small">
                    <div class="column-item">
                      <div class="separator">
                        <h2 class="pl-2">Summary</h2>
                      </div>
                      <div class="flex flex-column gap-5">
                        <div class="section">
                          <div class="single-information">
                            <div class="title">Total Time</div>
                            <div class="information-value">{{ valueOrNV(report.voyageReportData.totalTime_d, "1.1-1", "d") }}</div>
                          </div>
                          <div class="single-information">
                            <div class="title">Total Distance</div>
                            <div class="information-value">{{ valueOrNV(report.voyageReportData.totalDistance_nm, "1.0-0", "nm") }}</div>
                          </div>
                        </div>
                        <div class="section">
                          <div class="single-information">
                            <div class="title">Time at Sea</div>
                            <div class="information-value">{{ valueOrNV(report.voyageReportData.timeAtSea_d, "1.1-1", "d") }}</div>
                          </div>
                          <div class="single-information">
                            <div class="title">Time at Sea</div>
                            <div class="information-value">
                              {{
                                valueOrNV(report.voyageReportData.timeAtSea_ratio !== null ? report.voyageReportData.timeAtSea_ratio * 100 : null, "1.1-1", "%")
                              }}
                            </div>
                          </div>
                          <div class="single-information">
                            <div class="title">Av. Speed SOG</div>
                            <div class="information-value">{{ valueOrNV(report.voyageReportData.sogAverage_kn, "1.1-1", "kn") }}</div>
                          </div>
                          <div class="single-information">
                            <div class="title">Av. M/E Fuel Con. Rate</div>
                            <div class="information-value">{{ valueOrNV(report.voyageReportData.fcrMeAverage_td, "1.1-1", "t/d") }}</div>
                          </div>
                        </div>
                        <div class="section">
                          <div class="single-information">
                            <div class="title">Sailing Type Laden</div>
                            <div class="information-value">{{ valueOrNV(report.voyageReportData.sailingTimeLaden_d, "1.1-1", "d") }}</div>
                          </div>
                          <div class="single-information">
                            <div class="title">Sailing Type Ballast</div>
                            <div class="information-value">{{ valueOrNV(report.voyageReportData.sailingTimeBallast_d, "1.1-1", "d") }}</div>
                          </div>
                        </div>
                        <div class="section">
                          <div class="single-information">
                            <div class="title">EEOI</div>
                            <div class="information-value">
                              {{ valueOrNV(report.voyageReportData.eeio_gtnm, "1.1-1", "") }}
                              <span *ngIf="report.voyageReportData.eeio_gtnm !== null">gCO<sub>2</sub>/tnm</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="color-ci-2-b flex text-xs pt-3">
                  All visible data, with the exception of the map, are based on manual data, reported by the ship crew. The map is created with sensor
                  measurements.
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">No reports available</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
